import NavbarSettings from './NavbarSettings';
import NavbarIcon from './NavbarIcon';
import NavbarProfile from './NavbarProfile';
import React from 'react';
import NavBarNotification from './NavBarNotification';
import NavBarActionableTrades from './NavBarActionableTrades';
import NavBarPendingOffers from './NavBarPendingOffers';
import NavBarSteamAccountSelect from './NavBarSteamAccountSelect';
import NavbarCart from './NavbarCart';
import Wallet from './wallet/Wallet';
import NavbarLinks from './NavbarLinks';
import NavBarAdminActionableTransaction from "./NavBarAdminActionableTransaction";
import NavBarAdminActionableTrades from "./NavBarAdminActionableTrades";

const NavbarWeb = () => {
    return (
        <nav
            className="lg:block hidden fixed top-0 left-0 right-0 transition-all duration-300 z-50 bg-light dark:bg-dark border-b border-neutral-200 dark:border-neutral-700 h-[80px]"
        >
            <div className="flex justify-between h-full px-4">
                <div className="flex xl:space-x-4 space-x-2">
                    <NavbarIcon/>
                    <NavbarLinks/>
                </div>
                <div className="flex xl:space-x-4 space-x-2 items-center">
                    <NavBarAdminActionableTransaction/>
                    <NavBarAdminActionableTrades/>
                    <NavBarPendingOffers/>
                    <NavBarActionableTrades/>
                    <NavBarSteamAccountSelect/>
                    <NavbarProfile/>
                    <Wallet/>
                    <NavbarCart/>
                    <NavBarNotification/>
                    <NavbarSettings/>
                </div>
            </div>
        </nav>
    );
};

export default NavbarWeb;